document.addEventListener('DOMContentLoaded', () => {
  const getSectionIds = () => {
    const cartComponent = document.querySelector('cart-notification');
    if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
      const ids = cartComponent.getSectionsToRender().map((section) => section.id);
      // header section needed for cart icon bubble update
      if (!ids.includes('header')) ids.push('header');
      return ids;
    }
    return ['cart-notification', 'header'];
  };

  const handleAddToCart = async (e) => {
    const btn = e.target.closest('.add-to-cart-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('loading');

    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: getSectionIds(),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body,
      });

      const cartData = await response.json();

      if (response.status !== 200) {
        let errorMessage = cartData.description || 'An error occurred.';
        alert(errorMessage);
        return;
      }

      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) {
        cartNotification.renderContents(cartData);
      }

      btn.classList.add('added');
      setTimeout(() => {
        btn.classList.remove('added');
      }, 2000);

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Could not add item to cart. Please try again.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  };

  document.body.addEventListener('click', handleAddToCart);

  document.body.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const btn = e.target.closest('.add-to-cart-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        btn.click(); // Trigger the click handler
      }
    }
  });
});
